<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="show"
      persistent
      width="70%"
      height="80%"
    >
      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          Help for JLL’s Network Builder Tool
        </v-card-title>
  
        <v-card-text class="grey lighten-3">
          <v-container>
            <v-layout column style="height: 60vh; position: relative">
              <v-flex xs12 style="overflow: auto">

                <div class="helpcontent-container">
                  <v-card class="ml-1 mr-1 mt-2">
                  <div class="helpcontent pa-5">
                    <h1>Network Builder Tool</h1>
                    <img :src="require('../assets/na-adjusters-screen.png')" />
                    
                    <h4>Annual Revenue</h4>
                    <p>
                      This slider adjusts the company’s total annual sales revenue. Each cost bucket is reflected as a fixed % of total revenue. 
                    </p>
                    
                    <h4># of Distribution Centers</h4>
                    <p>
                      Slider adds/reduces the # of distribution centers in the national network.
                      <ul>
                        <li>Total Square footage is divided equally across the distribution centers</li>
                        <li>Use the “Locations” button to customize the locations. </li>
                      </ul>
                    </p>
                    
                    <h4>Total Square Footage</h4>
                    <p>
                      Click the circle to enable this feature and adjust the total SF across the entire network
                    </p>
                    
                    
                    
                    <h1>Adjust Assumptions</h1>
                    
                    <h2>Freight Assumptions Tab</h2>
                    <img :src="require('../assets/na-freight-assumptions-screen.png')" />
                    
                    <h4>By Percentage of Revenue</h4>
                    <p>
                      Increase the total inbound and outbound logistics cost as a proportionate percentage of annual sales revenue 
                    </p>
                    
                    <h4>Inbound Cost and Outbound Costs</h4>
                    <p>
                      Click the circle to enable this feature and input custom inbound and outbound shipping costs. Custom costs will take priority over the % of revenue slider.
                    </p>
                    
                    
                    <h2>Inventory Assumptions Tab</h2>
                    <img :src="require('../assets/na-inventory-assumptions-screen.png')" />
                    
                    <h4>By % of revenue</h4>
                    <p>
                      Increase the total inventory cost as a proportionate percentage of annual sales revenue
                    </p>
                    
                    <h4>Total Holdings</h4>
                    <p>
                      Click the circle to enable this feature and input a custom inventory holding cost
                    </p>
                    
                    <h4>Cost of Capital</h4>
                    <p>
                      Use this slider to adjust the cost of capital
                    </p>
                      
                    <h4>Shrink/Obsolescence</h4>
                    <p>
                      Use this slider to adjust the opportunity cost of lost, damaged, or obsolete inventory
                    </p>
                    
                    
                    <h2>Labor Assumptions Tab</h2>
                    <img :src="require('../assets/na-labor-assumptions-screen.png')" />
                    
                    <h4>Hourly Rate</h4>
                    <p>
                      Use this slide to adjust the hourly wage of warehouse employees. This rate will be applied across the network. 
                    </p>
                    
                    <h4>Personnel Per 10k SQFT</h4>
                    <p>
                      Use this slider to adjust the # of employees across the network per 10,000 sf. 
                    </p>
                    
                    
                    <h2>Lease Assumptions Tab</h2>
                    <img :src="require('../assets/na-lease-assumptions-screen.png')" />
                    
                    <h4>Rate per sqft per year</h4>
                    <p>
                      Use this slider to enter a custom lease rate per SF per year for the warehouse facility. This rate will be applied across the network.
                    </p>
                    
                    
                    
                    <h1>What-if? Analysis</h1>
                    <img :src="require('../assets/na-whatif-adjusters-screen.png')" />
                    
                    <h4>Change # of distribution centers</h4>
                    <p>
                      This slider will add or delete locations and will approximate the impact on costs.  Increasing the number of distribution centers will generally lower transportation costs but increase all others.
                    </p>
                    
                    <h4>Change Labor Costs</h4>
                    <p>
                      Simulate a % increase or decrease in overall labor costs across the entire network
                    </p>
                    
                    <h4>Change Lease Costs</h4>
                    <p>
                      Simulate a % increase or decrease in overall lease expense across the network
                    </p>
                    
                    
                    
                    <h1>Your Costs (Graph in upper left)</h1>
                    <img :src="require('../assets/na-costs-graph-screen.png')" />
                    <p>
                      Shows the breakdown of costs associated with each major bucket across the network. Scroll over each bar to show the $$ figure and % of total cost.
                    </p>
                    <p>
                      What-if Analysis shows the comparison difference between the base case model and the simulated model in real time. 
                    </p>
                    
                    
                    
                    <h1>Your Service Ranges (Graph in lower left)</h1>
                    <img :src="require('../assets/na-service-ranges-graph-screen.png')" />
                    <p>
                      Shows the service time for all outbound shipments nationwide. Scroll over each bar to show the % of shipments within that service time. What-if Analysis shows the comparison difference between the base case model and the simulated model in real time. 
                    </p>
                    
                    
                    
                    <h1>General</h1>
                    <ul>
                        <li>
                          Inbound shipments assume FTL delivery from the nearest major port and the costs are spread across the network. 
                        </li>
                        <li>
                          Outbound shipments are based on population data and assume small parcel shipments to the top 300 MSA’s nationwide.
                        </li>
                    </ul>
                  </div>
                  </v-card>
                </div>

              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>


        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="didSelectOK()"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'help-content',
  data () {
    return {
    }
  },

  props: { 
    show: Boolean
  },

  methods: {
    didSelectOK() {
      this.$emit('did-select-ok')      
    }
  },

  components: {
    'intro-bar': () => import ('@/components/IntroBar'),
  }

}

</script>


<style scoped>
.dialog-title {
  font-weight:bold;
  font-size:11pt;
}
.helpcontent-container {
  position: absolute;
  top: -8px;
  width: 100%;
  height: calc(100% - 8px);
  overflow-y:scroll;
}

.helpcontent h1 {
  border-bottom: 1px solid #aaa;
  font-size: 24pt;
  margin: 30px auto 20px auto;
  padding-bottom: 5px;
  text-align: center;
  width: 70%;
}
.helpcontent h1:nth-child(1) {
  margin-top: 0;
}
.helpcontent h2 {
  text-align: center;
  padding-top: 10px;
}
.helpcontent p {
  font-size: 12pt;
}
.helpcontent {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
.helpcontent img {
  box-shadow: 0 0 5px #777777;
  margin: 10px;
  width: calc(100% - 20px);
}
</style>